import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
  forwardRef,
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  NgControl,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { RRIInput } from '../../interfaces/input-settings.interface';

@Component({
  selector: 'rr-textarea-field',
  templateUrl: './textarea-field.component.html',
  styleUrls: ['./textarea-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextareaFieldComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => TextareaFieldComponent),
      multi: true,
    },
  ],
})
export class TextareaFieldComponent
  implements OnInit, ControlValueAccessor, Validator
{
  public data: string;
  public onChangeFn: any = (_: any) => {};
  public onTouch: any = () => {};
  public control: NgControl;
  private errorMessages = new Map<string, () => string>();
  @Input() settings: RRIInput<string>;
  @Input() disabled: boolean = false;
  @Input() required: boolean = false;
  @Input() customErrorMessages: Map<string, () => string>;
  @Output() clearInput: EventEmitter<string> = new EventEmitter();
  constructor(private inj: Injector) {
    if (this.required) {
      this.errorMessages.set(
        'required',
        () => `${this.settings.label} is required.`,
      );
    }
  }

  ngOnInit(): void {
    this.control = this.inj.get(NgControl, null);

    if (this.customErrorMessages && this.customErrorMessages.size) {
      this.errorMessages = new Map([
        ...Array.from(this.errorMessages.entries()),
        ...Array.from(this.customErrorMessages.entries()),
      ]);
    }
  }

  public onClearInput(): void {
    if (!this.settings.disableClearEvent) {
      if (this.settings.defaultValue) {
        this.data = this.settings.defaultValue;
      } else {
        this.data = '';
      }
    }
    this.clearInput.emit(this.data);
    this.onChange(this.data);
  }

  public writeValue(text: string): void {
    this.data = text;
  }
  public registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouch = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  public onChange(data) {
    this.onChangeFn(data);
  }
  public onTouched() {
    this.onTouch();
  }
  public get invalid(): boolean {
    return this.control ? this.control.invalid : false;
  }

  public get showError(): boolean {
    if (!this.control) {
      return false;
    }

    const { dirty, touched, value } = this.control;

    return this.invalid ? dirty || touched || !!value : false;
  }

  public get errors(): Array<string> {
    if (!this.control) {
      return [];
    }

    const { errors } = this.control;
    if (this.errorMessages.size === 0) {
      return [];
    }
    return Object.keys(errors).map((key) => {
      return this.errorMessages.has(key)
        ? this.errorMessages.get(key)()
        : 'error: ' + key;
    });
  }
  public getInputControlClasses(): string {
    let returnClass = this.required ? 'fg-required' : '';
    if (this.control) {
      if (typeof this.control.invalid !== 'undefined') {
        returnClass += this.control.invalid ? 'fg-invalid' : 'fg-valid';
      }
    }
    return returnClass;
  }
  public validate(_control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
